// 自动导入所有svg图标
const req = require.context('@/assets/icon/svgs', false, /\.svg$/)
const requireAll = (requireContext) => requireContext.keys().map(requireContext)
requireAll(req)
